import React from 'react';
import { Switch } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

export default withStyles((theme) => ({
  root: {
    width: 40,
    height: 24,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        border: `1px solid ${theme.colors.blue}`,
        backgroundColor: theme.colors.blue,
        opacity: 1,
      },
    },
    '&$focusVisible $thumb': {
      color: theme.colors.lightGreen,
    },
  },
  thumb: {
    width: 22,
    height: 22,
  },
  track: {
    height: 22,
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});
